/** Five disciplines. The interface numbers them as an index, not as a process. */
export const services = [
  { slug: 'mobile-games', icon: 'gamepad', features: 4, link: '/games' },
  { slug: 'pc-games',     icon: 'monitor', features: 4, link: '/games' },
  { slug: 'mobile-apps',  icon: 'phone',   features: 4, link: '/contact' },
  { slug: 'websites',     icon: 'code',    features: 4, link: '/contact' },
  { slug: 'ai-search',    icon: 'search',  features: 4, link: '/lab' },
];
